import React, { useState } from 'react';
import './App.css';
import ThreeDExperience from './ThreeDExperience';
import Portfolio from './components/Portfolio';

const App = () => {
  const [is3D, setIs3D] = useState(false);

  return (
    <div className="root">
      {is3D ? (
        <ThreeDExperience />
      ) : (
        <Portfolio launch3D={() => setIs3D(true)} />
      )}
    </div>
  );
};

export default App;
